// @flow

import {ApiClient} from 'docs/data';
import {accountLoading, accountLoaded} from 'docs/data/account/AccountReducer';
import {transformAccount, transformNavigation} from 'docs/server/transformers';

import type {Country, Dispatcher} from 'docs/data';
import type {AccountEvent} from 'docs/data/account/AccountReducer';

export const setCountry = (
  api: ApiClient,
  dispatch: Dispatcher<AccountEvent>,
) => async (country: Country, setNavigation: any) => {
  dispatch(accountLoading());

  const response = await api.saveAccountSettings({
    country: country.code,
    locale: undefined,
  });

  const account = transformAccount(response.account);
  const navigation = transformNavigation(response.navigation);

  // TODO (nkohari): This should be an action which is dispatched
  setNavigation(navigation);

  dispatch(accountLoaded(account));
};
